export default __webpack_public_path__ + "static/gs-R-code-3770f5ec4836c9d32a1fc28a5cffe7e3.webp";